const dangerColor = "#db0d26";
const focusColor = "#36b3be";
const regularColor = "#ddd";
const placeholderColor = "#aaa";

export const outlinedInputSx = (textFocus, textError) => {
  return {
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
      outline: "none",
    },
    "&.MuiOutlinedInput-root": {
      borderRadius: "4px",
      border: textError
        ? `1px solid ${dangerColor}`
        : textFocus
        ? `1px solid ${focusColor}`
        : `1px solid ${regularColor}`,
      width: "100%",
    },
    "& .MuiOutlinedInput-input": {
      fontSize: "14px",
    },
    "& input::placeholder": {
      color: placeholderColor,
    },
    "& textarea::placeholder": {
      color: placeholderColor,
    },
  };
};

export const selectionSx = (
  selectionFocus,
  selectionError,
  selectionDisabled,
) => {
  return {
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
      outline: "none",
    },
    "&.MuiOutlinedInput-root": {
      borderRadius: "4px",
      border: selectionError
        ? `1px solid ${dangerColor}`
        : selectionFocus
        ? `1px solid ${focusColor}`
        : `1px solid ${regularColor}`,
      width: "100%",
    },
    "& .MuiOutlinedInput-input": {
      ...(selectionDisabled && { cursor: "not-allowed" }),
      fontSize: "14px",
    },
  };
};

export const menuItemSx = () => {
  return {
    "&.MuiMenuItem-root": {
      whiteSpace: "normal",
      fontSize: 14,
    },
  };
};

export const datePickerSx = (datepickerFocus, datepickerError) => {
  return {
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
      outline: "none",
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: "4px",
      border: datepickerFocus
        ? `1px solid ${focusColor}`
        : datepickerError
        ? `1px solid ${dangerColor}`
        : `1px solid ${regularColor}`,
      fontSize: 14,
    },
    "&.MuiTextField-root": {
      width: "100%",
    },
    "& .MuiButtonBase-root": {
      color: datepickerFocus ? focusColor : regularColor,
    },
    "& input::placeholder": {
      color: placeholderColor,
    },
  };
};
